import { observer } from "mobx-react"
import { t } from "@lingui/macro"
import { useMemo, useCallback } from "react"
import { FormControl } from "@mui/material"

import { TenantsDetailsStore } from "./store"

import { useStore } from "src/store/lib/useStore"
import { AutoCompleteTextField } from "src/components/AutoCompleteTextField"

export const StatusFilter = observer(() => {
    const store = useStore(TenantsDetailsStore)

    const statusOptions = useMemo(() => {
        return store.getStatusOptions().map((option) => ({
            ...option,
            label: t({ id: option.label }),
        }))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const selectedStatusOptions = useMemo(() => {
        // Create a lookup map for faster access
        const optionsMap = Object.fromEntries(
            statusOptions.map((option) => [option.id, option]),
        )
        // Use the map for O(1) lookups instead of O(n) finds
        return store.statusFilter
            .map((status) => optionsMap[status])
            .filter(Boolean)
    }, [store.statusFilter, statusOptions])

    const handleStatusChange = useCallback(
        (_, values) => {
            const statusIds = Array.isArray(values)
                ? values
                      .map((option) =>
                          typeof option === "object"
                              ? String((option as { id: string }).id)
                              : "",
                      )
                      .filter(Boolean)
                : []
            void store.setStatusFilter(statusIds)
        },
        [store],
    )

    return (
        <FormControl size="small">
            <AutoCompleteTextField
                id="status-filter"
                limitTags={1}
                options={statusOptions}
                value={selectedStatusOptions}
                onChange={handleStatusChange}
                label={t`invoices-view.status-filter-label`}
                multiple
                sx={{
                    width: "100%",
                }}
            />
        </FormControl>
    )
})
